import { defineComponent as _defineComponent } from 'vue';
import { useAnimationFrame } from "@/composables/sensors/animationFrame";
import { computed, ref, watch, onMounted } from "vue";
import { Transform } from "./modules/geometry";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AdaptiveGrid',
    props: {
        viewportBounds: null,
        viewportBoundingBox: null,
        transform: null
    },
    setup(__props) {
        const props = __props;
        const lineGap = 10;
        const landmarkLines = [
            {
                condition: (zoom) => zoom > 0.15,
                frequency: 10,
                width: 1,
            },
            {
                condition: (_zoom) => true,
                frequency: 20,
                width: 2,
            },
            {
                condition: (zoom) => zoom <= 0.5,
                frequency: 100,
                width: 4,
            },
            {
                condition: (zoom) => zoom <= 0.2,
                frequency: 200,
                width: 8,
            },
        ];
        const colors = {
            grid: "black",
            landmark: "black",
        };
        onMounted(() => {
            const element = canvas.value;
            const style = getComputedStyle(element);
            colors.grid = style.getPropertyValue("--grid-color");
            colors.landmark = style.getPropertyValue("--landmark-color");
        });
        const canvas = ref(null);
        const context = computed(() => { var _a, _b; return (_b = (_a = canvas.value) === null || _a === void 0 ? void 0 : _a.getContext("2d")) !== null && _b !== void 0 ? _b : null; });
        let redraw = true;
        watch(() => [props.transform, props.viewportBounds], () => (redraw = true), { deep: true });
        useAnimationFrame(() => {
            const ctx = context.value;
            if (ctx && redraw) {
                ctx.canvas.width = ctx.canvas.offsetWidth;
                ctx.canvas.height = ctx.canvas.offsetHeight;
                ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                ctx.resetTransform();
                new Transform().scale([props.transform.k, props.transform.k]).applyToContext(ctx);
                renderGrid(ctx);
                redraw = false;
            }
        });
        function renderGrid(ctx) {
            const zoom = props.transform.k;
            const pan = {
                x: props.transform.x / zoom,
                y: props.transform.y / zoom,
            };
            // standard lines
            if (zoom > 0.5) {
                ctx.strokeStyle = colors.grid;
                ctx.lineWidth = 1;
                ctx.beginPath();
                traceGrid(ctx, lineGap, pan, props.viewportBoundingBox);
                ctx.stroke();
            }
            // landmark lines
            ctx.strokeStyle = colors.landmark;
            landmarkLines.forEach((landmarkLine) => {
                if (landmarkLine.condition(zoom)) {
                    ctx.lineWidth = landmarkLine.width;
                    const gap = lineGap * landmarkLine.frequency;
                    ctx.beginPath();
                    traceGrid(ctx, gap, pan, props.viewportBoundingBox);
                    ctx.stroke();
                }
            });
        }
        /**
         * moves the contexts path along a grid with the specified parameters
         */
        function traceGrid(ctx, gap, pan, bounds) {
            const startOffset = {
                x: (pan.x % gap) - gap,
                y: (pan.y % gap) - gap,
            };
            const xAmount = bounds.width / gap + 2;
            const yAmount = bounds.height / gap + 2;
            // vertical
            for (let i = 0; i < xAmount; i++) {
                const x = startOffset.x + i * gap;
                ctx.moveTo(x, 0);
                ctx.lineTo(x, bounds.height);
            }
            // horizontal
            for (let i = 0; i < yAmount; i++) {
                const y = startOffset.y + i * gap;
                ctx.moveTo(0, y);
                ctx.lineTo(bounds.width, y);
            }
        }
        return { __sfc: true, lineGap, landmarkLines, props, colors, canvas, context, redraw, renderGrid, traceGrid };
    }
});
